import { Button, HStack, Link, Separator, Text, VStack } from "@chakra-ui/react";
import GoogleIcon from "@/assets/GoogleIcon.svg";
import { API_BASE_URL } from "@/config/env";
import { buildGoogleOAuthHref } from "@/utils/socialAuth";

interface SocialAuthOptionsProps {
  nextPath?: string | null;
  apiBaseUrl?: string | null;
}

export default function SocialAuthOptions({ nextPath, apiBaseUrl = API_BASE_URL }: SocialAuthOptionsProps) {
  const googleAuthHref = buildGoogleOAuthHref(apiBaseUrl, nextPath);

  if (!googleAuthHref) {
    return null;
  }

  return (
    <VStack w="full" gap={4}>
      <HStack w="full" align="center" justify="center">
        <Text fontSize="sm" color="gray.500" px={3}>
          or
        </Text>
        <Separator />
      </HStack>

      <Link href={googleAuthHref} w="full" _hover={{ textDecoration: "none" }}>
        <Button
          w="full"
          size="lg"
          variant="outline"
          bg="white"
          _hover={{ bg: "gray.50" }}
          _dark={{ bg: "gray.800", _hover: { bg: "gray.700" }, borderColor: "gray.600" }}
          border="1px solid"
          borderColor="gray.300"
        >
          <HStack gap={2}>
            <GoogleIcon />
            <Text>Sign in with Google</Text>
          </HStack>
        </Button>
      </Link>
    </VStack>
  );
}
